// Line/paragraph separators: valid in JSON but illegal in JS string literals,
// which trips up some parsers. Built from char codes so no literal control
// character ends up in this source file.
const LINE_SEPARATOR = String.fromCharCode(0x2028)
const PARAGRAPH_SEPARATOR = String.fromCharCode(0x2029)

/**
 * Serialize a structured-data object for embedding inside a
 * `<script type="application/ld+json">` tag.
 *
 * We escape `<` to its unicode form so the string `</script>` can never appear
 * in the output and break out of the script element, plus the two line
 * separators above. This is lossless — unlike running an HTML sanitizer over
 * the JSON, it never mutates the content itself.
 */
export const serializeJsonLd = (data: unknown): string =>
  JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .split(LINE_SEPARATOR)
    .join('\\u2028')
    .split(PARAGRAPH_SEPARATOR)
    .join('\\u2029')

export default serializeJsonLd
